import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { TYPE } from "../../../../theme/styles/globals"

export const H2 = styled.h2`
  font-family:${TYPE.SERIF_BOLD_FONT}, sans-serif;
  font-weight:normal;
  color:${props => props.color || "black"};
  font-size:54px;  
  line-height:54px;

  ${up('md')}{
    font-size:72px;
    line-height:72px;
  }
  
`